<script setup lang="ts">
import { ref } from 'vue';
import store from '@/store';
import CInput from '@/components/shared/CInput.vue';

const searchInputRef = ref('');

const handleSearchInput = () => {
    store.dispatch('mapStyleProperties/updateSearchQuery', searchInputRef.value);
};
</script>

<template>
    <div class="search-filters">
        <div class="search-and-categories d-flex align-items-end">
            <div class="search-input-container">
                <c-input
                    v-model="searchInputRef"
                    label="Search styles"
                    placeholder="Type to search..."
                    @input="handleSearchInput"
                />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.search-filters {
    margin-bottom: 16px;
}

.search-and-categories {
    gap: 16px;
}

.search-input-container {
    flex: 1;
    min-width: 250px;

    .search-input {
        width: 100%;
    }
}

.filter-actions {
    flex-shrink: 0;

    @media (max-width: 1024px) {
        align-self: flex-start;
    }
}

.category-select {
    min-width: 200px;
    flex-shrink: 0;

    @media (max-width: 1024px) {
        min-width: 150px;
    }

    .category-dropdown {
        padding: 8px 12px;
        border: 1px solid var(--gray-light);
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.2s ease;
        padding-right: 35px;
        width: 100%;
        height: 40px;

        &:hover {
            border-color: var(--primary-purple);
            box-shadow: 0 0 0 0.1rem rgba(0, 123, 255, 0.1);
        }

        &:focus {
            border-color: var(--primary-purple);
            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
        }

        option {
            padding: 8px 12px;
            color: #495057;
        }

        @media (max-width: 1024px) {
            font-size: 13px;
            padding: 6px 10px;
            padding-right: 30px;
        }
    }
}
</style>
